export default __webpack_public_path__ + "static/mobile-development-b62a6b9fae742f8d5ccc630391e6a187.webp";